import { showCreateNew } from './configActions';

const defaultState = {
  loading: true,
  databases: [],
  sources: [],
  showCreateNew: false,
  activeTab: '1',
  db: {
    key: '',
    title: '',
    hidden: true,
    show: false,
    new: false
  },
  source: {
    id: '',
    fullName: '',
    show: false,
    new: false
  },
  sblgroups: [],
  sblgroup: {
    id: '-1',
    name: '',
    database: '',
    show: false,
    new: false
  }
};

export default (state = defaultState, action) => {

  switch (action.type) {
    case 'DB_FETCH_BEGIN':
      return { ...defaultState, activeTab: (state.activeTab || '1') };
    case 'DB_FETCH_SUCCESS':
      return { ...state, loading: false, ...action.payload };
    case 'CONFIG_CHANGE_TAB':
      return { ...state, activeTab: action.payload };
    case 'DB_EDIT':
      return { ...state, db: { ...action.payload, show: true, new: false } };
    case 'DB_CANCEL':
      return { ...state, db: defaultState.db };
    case 'DB_SAVE_BEGIN':
      return { ...state, loading: true };
    case 'DB_SAVE_SUCCESS':
      return { ...state, loading: false, db: defaultState.db, databases: action.payload };
    case 'DB_DELETE_SUCCESS':
      return { ...state, loading: false, db: defaultState.db, databases: action.payload };
    case 'CONFIG_NEW_DB':
      return { ...state, db: { ...defaultState.db, show: true, new: true } };

    case 'CONFIG_NEW_SOURCE':
      return { ...state, source: { ...defaultState.source, show: true, new: true } };
    case 'SOURCE_EDIT':
      return { ...state, source: { ...action.payload, show: true, new: false } };
    case 'SOURCE_CANCEL':
      return { ...state, source: defaultState.source };
    case 'SOURCE_SAVE_BEGIN':
      return { ...state, loading: true };
    case 'SOURCE_SAVE_SUCCESS':
      return { ...state, loading: false, source: defaultState.source, sources: action.payload };
    case 'SOURCE_DELETE_SUCCESS':
      return { ...state, loading: false, source: defaultState.source, sources: action.payload };

    case 'CONFIG_SHOW_CREATE_NEW':
      return { ...state, showCreateNew: action.payload };

    case 'CONFIG_NEW_SBL_GROUP':
      return { ...state, sblgroup: { ...defaultState.sblgroup, show: true, new: true } };
    case 'SBL_GROUP_EDIT':
      return { ...state, sblgroup: { ...action.payload, show: true, new: false } };
    case 'SBL_GROUP_CANCEL':
      return { ...state, sblgroup: defaultState.sblgroup };
    case 'SBL_GROUP_SAVE_BEGIN':
      return { ...state, loading: true };
    case 'SBL_GROUP_SAVE_SUCCESS':
      return { ...state, loading: false, sblgroup: defaultState.sblgroup, sblgroups: action.payload };
    case 'SBL_GROUP_DELETE_SUCCESS':
      return { ...state, loading: false, sblgroup: defaultState.sblgroup, sblgroups: action.payload };
    case 'SBL_GROUP_NEW_SOURCE':
      return { ...state, sblgroup: { ...defaultState.sblgroup, show: true, new: true } };
    case 'CONFIG_EDIT_INPUT':
        
      state[action.payload.entity][action.payload.attr] = action.payload.value;

      return { ...state, db: state.db };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/config/configReducers.js